module.exports = __webpack_public_path__ + "img/3.7eaa6ef6.png";